<template>
    <section class="description">
        <div class="description__content">
            <h4 v-if="title">{{ title }}</h4>
            <div v-if="content" v-html="content"></div>
        </div>
    </section>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'Description',
    props: {
        title: VueTypes.string.isRequired,
        content: VueTypes.string.isRequired
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
